export default {
    orders: {
        actionUndo: {
            message: "Si vous avez cliqué par erreur, cliquez sur le lien ci-dessous pour revenir en arrière.",
            undo: "Cliquez pour annuler"
        }
    }
}